import Tooltip from '@creditflowresearch/uilib/Tooltip';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/ProductAbbrevation/productAbbrevation.module.scss';

export const ProductAbbreviation = ({ row: deal }: { row: IDealCellData }) => (
  <div className={ styles.productCol } data-test="dealRowProduct">
    <Tooltip content={ deal.product.name }>
      { deal.product.abbreviation }
    </Tooltip>
  </div>
);
